import { NgModule, ModuleWithProviders, Injectable, APP_INITIALIZER, Injector } from '@angular/core';
import { ApiService } from './api.service';
import { ServiceProxiesModule, API_BASE_URL } from './service-proxies/service-proxies';
import { StorageService } from '@fs/core'

//注意:所有ServiceProxies均不可使用constructor注入
@NgModule({
  imports: [
    ServiceProxiesModule
  ],
  providers: [
    ApiService,
    {
      provide: API_BASE_URL,
      useFactory: API_BASE_URL_Factory,
      deps: [StorageService]
    }
  ]
})
export class ApiModule{
  
}
export function API_BASE_URL_Factory(storageService: StorageService) {
  return storageService.AppSettings.Value.remoteServiceBaseUrl;
}

